'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_GroceryItemSortType() {
}
export { $c_Lmealorama_GroceryItemSortType as $c_Lmealorama_GroceryItemSortType };
$p = $c_Lmealorama_GroceryItemSortType.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_GroceryItemSortType;
/** @constructor */
function $h_Lmealorama_GroceryItemSortType() {
}
export { $h_Lmealorama_GroceryItemSortType as $h_Lmealorama_GroceryItemSortType };
$h_Lmealorama_GroceryItemSortType.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
var $d_Lmealorama_GroceryItemSortType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i(0, "mealorama.GroceryItemSortType", ({
  jz: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lmealorama_GroceryItemSortType as $d_Lmealorama_GroceryItemSortType };
//# sourceMappingURL=mealorama.-Grocery-Item-Sort-Type.js.map
